import { render, staticRenderFns } from "./user-details.vue?vue&type=template&id=186265d2&"
import script from "./user-details.vue?vue&type=script&lang=js&"
export * from "./user-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports